export default __webpack_public_path__ + "static/media/Machine Icon, Orange.e1220992.png";